import {gql} from "@apollo/client";

export const SIGNIN_STORE_USER = `query storeUserSignIn($storeUserSignInInput: StoreUserSignInInput!) {
  storeUserSignIn(storeUserSignInInput: $storeUserSignInInput) {
    accessToken
    refreshToken
    type
    roles
    availableFeatureNames
    storeUser{
     stores{
        correlationId
        name
        planId
        storeAllowedFeatures
        userAllowedFeatures
        storeStaffRole
        suggestedTipPercentages{
        tipPercentage
        }
        deliveryPolicies{
        startMile
        endMile
        deliveryChargeCents
        }
      }
      correlationId
      firstName
      lastName
      email
      phoneNumber
      employerName
      stores{
      correlationId
      name
      nonEnglishName
      primaryContactPhoneNumber
      primaryContactEmail
      primaryContactFirstName
      primaryContactLastName
      style
      employeeCount
      connectedAccountId
      bucketKeyName
      categories {
        correlationId
        name
      }
      operationHours {
        day
        startTimeInSeconds
        endTimeInSeconds
      }
      address {
        addressLine1
        addressLine2
        city
        state
        zipCode
      }
        employeeCount
        averageRating
        planId
        storeAllowedFeatures
        userAllowedFeatures
        storeStaffRole
      }
    }
  }
}`;

export const SIGNIN_EMPLOYEE_USER = `query storeEmployeeSignIn($storeEmployeeSignInInput: StoreEmployeeSignInInput!) {
  storeEmployeeSignIn(storeEmployeeSignInInput: $storeEmployeeSignInInput) {
    type
    roles
    refreshToken
    accessToken
    storeUser {
      correlationId
      firstName
      lastName
      email
      phoneNumber
      bucketKeyName
      employerName
      stores{
        correlationId
        name
        planId
        storeAllowedFeatures
        userAllowedFeatures
      }
    }
  }
}`;

export const REGISTER_STORE_USER = `mutation registerStoreUser($createStoreUserInput: CreateStoreUserInput!) {
    registerStoreUser(createStoreUserInput: $createStoreUserInput) {
        correlationId
        firstName
        lastName
        email
        phoneNumber
        employerName
    }
}`;

export const ACTIVATE_ENTERPRISE_STORE = `mutation activateEnterpriseStore($storeCorrelationId: UUID!) {
  activateEnterpriseStore(storeCorrelationId: $storeCorrelationId) {
    correlationId
    name
    planId
    storeAllowedFeatures
    userAllowedFeatures
    storeStaffRole
  }
}`;

export const UPDATE_STORE_USER = `mutation updateStoreUser($updateStoreUserInput: UpdateStoreUserInput!) {
    updateStoreUser(updateStoreUserInput: $updateStoreUserInput) {
        correlationId
        firstName
        lastName
        email
        phoneNumber
        employerName
    }
}`;

export const RESET_PASSWORD = gql`
    mutation resetPassword($resetPasswordInput: ResetPasswordInput!) {
        resetPassword(resetPasswordInput: $resetPasswordInput) {
            requestProcessed
        }
    }
`;

export const SAVE_NEW_PASSWORD = gql`
    mutation saveNewPassword($saveNewPasswordInput: SaveNewPasswordInput!) {
        saveNewPassword(saveNewPasswordInput: $saveNewPasswordInput) {
            message
        }
    }
`;

export const ACTIVATE_USER_ACCOUNT = gql`
    mutation activateUserAccount(
        $activateUserAccountInput: ActivateUserAccountInput!
    ) {
        activateUserAccount(activateUserAccountInput: $activateUserAccountInput) {
            activated
            message
        }
    }
`;

export const CREATE_RESTAURANT = `mutation createStore($createStoreInput: CreateStoreInput!) {
  createStore(createStoreInput: $createStoreInput) {
    correlationId
    name
    address {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    operationHours {
      day
      startTimeInSeconds
      endTimeInSeconds
    }
    planId
    storeAllowedFeatures
    userAllowedFeatures
    primaryContactEmail
    primaryContactFirstName
    primaryContactLastName
    primaryContactPhoneNumber
    style
    timeZone
    deliveryPolicies {
      deliveryChargeCents
      startMile
      endMile
    }
  }
}`;



export const UPDATE_RESTAURANT = `mutation updateStore($updateStoreInput: UpdateStoreInput!) {
  updateStore(updateStoreInput: $updateStoreInput) {
    correlationId
    name
    nonEnglishName
    operationMode
    primaryContactFirstName
    primaryContactLastName
    primaryContactEmail
    primaryContactPhoneNumber
    address {
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
    operationHours {
      day
      startTimeInSeconds
      endTimeInSeconds
    }
    suggestedTipPercentages {
      tipPercentage
    }
    defaultLocale
    enabledLocales
    secondLanguage
    receiptLanguageRestaurantCopy
    receiptLanguageCustomerCopy
    receiptLanguageKitchenCopy
    printReceiptAfterPayment
    popularItemSortingEnabled
    popularItemSortingDays
    passCardProcessingFeeToCustomer
    cardProcessingFeeEnabledByPlatform
    cardProcessingFeePercentBps
    deliveryPolicies {
      startMile
      endMile
      deliveryChargeCents
    }
    planId
    storeAllowedFeatures
    userAllowedFeatures
  }
}`;

export const CREATE_QUICK_SERVICE_CHOICE_GROUP = `
  mutation createQuickServiceChoiceGroup($input: CreateQuickServiceChoiceGroupInput!) {
    createQuickServiceChoiceGroup(input: $input) {
      correlationId
      name
      description
      renderSequence
    }
  }
`;

export const UPDATE_QUICK_SERVICE_CHOICE_GROUP = `
  mutation updateQuickServiceChoiceGroup($input: UpdateQuickServiceChoiceGroupInput!) {
    updateQuickServiceChoiceGroup(input: $input) {
      correlationId
      name
      description
      renderSequence
    }
  }
`;

export const ADD_QUICK_SERVICE_CHOICE_GROUP_ITEM = `
  mutation addQuickServiceChoiceGroupItem($input: AddQuickServiceChoiceGroupItemInput!) {
    addQuickServiceChoiceGroupItem(input: $input) {
      correlationId
    }
  }
`;

export const UPDATE_QUICK_SERVICE_CHOICE_GROUP_ITEM = `
  mutation updateQuickServiceChoiceGroupItem($input: UpdateQuickServiceChoiceGroupItemInput!) {
    updateQuickServiceChoiceGroupItem(input: $input) {
      correlationId
    }
  }
`;

export const CREATE_QUICK_SERVICE_COMBO = `
  mutation createQuickServiceCombo($input: CreateQuickServiceComboInput!) {
    createQuickServiceCombo(input: $input) {
      correlationId
      name
      priceCents
      taxRate
    }
  }
`;

export const UPDATE_QUICK_SERVICE_COMBO = `
  mutation updateQuickServiceCombo($input: UpdateQuickServiceComboInput!) {
    updateQuickServiceCombo(input: $input) {
      correlationId
      name
      priceCents
      taxRate
    }
  }
`;

export const CREATE_QUICK_SERVICE_COMBO_GROUP = `
  mutation createQuickServiceComboGroup($input: CreateQuickServiceComboGroupInput!) {
    createQuickServiceComboGroup(input: $input) {
      correlationId
    }
  }
`;

export const UPDATE_QUICK_SERVICE_COMBO_GROUP = `
  mutation updateQuickServiceComboGroup($input: UpdateQuickServiceComboGroupInput!) {
    updateQuickServiceComboGroup(input: $input) {
      correlationId
    }
  }
`;


export const UPLOAD_RESTAURANT_IMAGE = `mutation createUploadPreSignedUrlForStore($createStorePreSignedUrlInput: CreateStorePreSignedUrlInput!) {
  createUploadPreSignedUrlForStore(createStorePreSignedUrlInput: $createStorePreSignedUrlInput) {
    preSignedUrl
  }
}`;

export const UPLOAD_CATEGORY_IMAGE = `mutation createUploadPreSignedUrlForCategory($createCategoryPreSignedUrlInput: CreateCategoryPreSignedUrlInput!) {
  createUploadPreSignedUrlForCategory(createCategoryPreSignedUrlInput: $createCategoryPreSignedUrlInput) {
    preSignedUrl
  }
}`;

export const UPLOAD_COMBO_IMAGE = `mutation createUploadPreSignedUrlForCombo($createComboPreSignedUrlInput: CreateComboPreSignedUrlInput!){
  createUploadPreSignedUrlForCombo(createComboPreSignedUrlInput: $createComboPreSignedUrlInput) {
    preSignedUrl
  }
}`;

export const UPLOAD_CATEGORY_ITEM_IMAGE = `mutation createUploadPreSignedUrlForItem($createItemPreSignedUrlInput: CreateItemPreSignedUrlInput!) {
  createUploadPreSignedUrlForItem(createItemPreSignedUrlInput: $createItemPreSignedUrlInput) {
    preSignedUrl
  }
}`;

export const UPLOAD_EMPLOYEE_IMAGE = `mutation createUploadPreSignedUrlForUser($createUserPreSignedUrlInput: CreateUserPreSignedUrlInput!) {
  createUploadPreSignedUrlForUser(createUserPreSignedUrlInput: $createUserPreSignedUrlInput) {
    preSignedUrl
  }
}`;

export const REFRESH_ACCESS_TOKEN = `mutation refreshAccessToken($refreshAccessTokenInput: RefreshAccessTokenInput!){
    refreshAccessToken(refreshAccessTokenInput: $refreshAccessTokenInput) {
			accessToken
    	refreshToken
    }
}`;

export const CREATE_REVIEW = `mutation createReview($createReviewInput: CreateReviewInput!) {
  createReview(createReviewInput: $createReviewInput) {
    createdAt
    correlationId
    storeCorrelationId
    content
    authorId
    replyTo
    rating
  }
}`;

export const ADD_CATEGORY = `mutation addCategory($addCategoryInput: AddCategoryInput!){
  addCategory(addCategoryInput: $addCategoryInput){
    name
    correlationId
  }
}`;

export const UPDATE_CATEGORY = `mutation updateCategory($updateCategoryInput: UpdateCategoryInput!) {
  updateCategory(updateCategoryInput: $updateCategoryInput) {
    correlationId
    name
    nonEnglishName
  }
}
`;

export const ADD_MENU_ITEM = `mutation addItem($addItemInput: AddItemInput!){
  addItem(addItemInput: $addItemInput){
    englishName
    nonEnglishName
    englishDescription
    nonEnglishDescription
    priceCents
    isQuickServiceChoiceItem
    enterpriseEnabled
    correlationId
    bucketKeyName
   itemOptions  {
       correlationId
				name
				nonEnglishName
				description
        renderSequence
        isRequired
        multipleSelectionsAllowed
        itemOptionElements {
        correlationId
				name
				nonEnglishName
				description
				renderSequence
				priceCents
          }    
      }
  }
}
`;

export const ADD_OPTION = `mutation addItemOption($addItemOptionInput: AddItemOptionInput!){
addItemOption(addItemOptionInput: $addItemOptionInput){
	correlationId
 }
}
`;

export const UPDATE_MENU_ITEM = `mutation updateItem($updateItemInput: UpdateItemInput!){
updateItem(updateItemInput: $updateItemInput){
  correlationId
  englishName
  nonEnglishName
  englishDescription
  nonEnglishDescription
  priceCents
  isQuickServiceChoiceItem
  enterpriseEnabled
  bucketKeyName
  abbreviation,
  taxRate,
  itemOptions {
    correlationId
    name
    description
    renderSequence
    isRequired
    multipleSelectionsAllowed
    itemOptionElements {
      correlationId
      name
      description
      renderSequence
      priceCents
    }
  }
 }
}
`;

export const UPDATE_ITEM_OPTION = `mutation updateItemOption($updateItemOptionInput: UpdateItemOptionInput!){
  updateItemOption(updateItemOptionInput: $updateItemOptionInput){
    correlationId
    name
    nonEnglishName
    description
    renderSequence
    isRequired
    multipleSelectionsAllowed
    translations {
      locale
      name
      description
    }
   }
  }
`;

export const ADD_MENU_ITEM_OPTION = `mutation addItemOption($addItemOptionInput: AddItemOptionInput!){
  addItemOption(addItemOptionInput: $addItemOptionInput){
    correlationId
    name
    nonEnglishName
    description
    renderSequence
    isRequired
    multipleSelectionsAllowed
    translations {
      locale
      name
      description
    }
    itemOptionElements {
      correlationId
      name
      nonEnglishName
      description
      renderSequence
      priceCents
      translations {
        locale
        name
        description
      }
    }
   }
  }
`;

export const UPDATE_ITEM_OPTION_ELEMENT = `mutation updateItemOptionElement($updateItemOptionElementInput: UpdateItemOptionElementInput!){
  updateItemOptionElement(updateItemOptionElementInput: $updateItemOptionElementInput){
    correlationId
    name
    nonEnglishName
    description
    renderSequence
    priceCents
    translations {
      locale
      name
      description
    }
   }
  }
`;

export const ADD_ITEM_OPTION_ELEMENT = `mutation addItemOptionElement($addItemOptionElementInput: AddItemOptionElementInput!){
  addItemOptionElement(addItemOptionElementInput: $addItemOptionElementInput){
    correlationId
    name
    nonEnglishName
    description
    renderSequence
    priceCents
    translations {
      locale
      name
      description
    }
   }
  }
`;

export const ADD_TABLE = `mutation createStoreTable($createStoreTableInput: CreateStoreTableInput!){
  createStoreTable(createStoreTableInput: $createStoreTableInput){
    correlationId
    storeCorrelationId
    tableNumber
    tableSize
    section
    status
    currentOrderCorrelationId
  }
}
`;

export const UPDATE_TABLE = `mutation updateStoreTable($updateStoreTableInput: UpdateStoreTableInput!){
    updateStoreTable(updateStoreTableInput: $updateStoreTableInput){
      correlationId
      storeCorrelationId
      tableNumber
      tableSize
      section
      status
      currentOrderCorrelationId
    }
  }
`;

export const SAVE_TABLE_LAYOUTS = `mutation SaveTableLayouts($saveTableLayoutsInput: [SaveTableLayoutInput!]!) {
  saveTableLayouts(saveTableLayoutsInput: $saveTableLayoutsInput) {
    tableId
    tableCorrelationId
    storeCorrelationId
    sectionId
    x
    y
    width
    height
    rotation
    shape
  }
}`;

export const UPDATE_STORE_PRINTER = `mutation updateStorePrinter($updateStorePrinterInput: UpdateStorePrinterInput!){
    updateStorePrinter(updateStorePrinterInput: $updateStorePrinterInput){
      correlationId
      assignedName
      model
      ipAddress
      port
      protocol
      isReceiptPrinter
      purpose
      enabled
    }
  }
`;

export const ADD_STORE_PRINTERS = `mutation addStorePrinters($addStorePrintersInput: AddStorePrintersInput!) {
  addStorePrinters(addStorePrintersInput: $addStorePrintersInput) {
    correlationId
    assignedName
    model
    ipAddress
    port
    protocol
    isReceiptPrinter
    purpose
    enabled
  }
}`;

export const DROP_STORE_PRINTERS = `mutation dropStorePrinters($dropStorePrintersInput: DropStorePrintersInput!) {
  dropStorePrinters(dropStorePrintersInput: $dropStorePrintersInput)
}`;

export const ADD_COMBO = `mutation createCombos($createCombosInput: CreateCombosInput!){
  createCombos(createCombosInput: $createCombosInput){
      correlationId
      englishName
      nonEnglishName
      englishDescription
      nonEnglishDescription
      priceCents
      itemList{
      	correlationId
      	abbreviation
      	englishName
      	nonEnglishName
      	englishDescription
        nonEnglishDescription
        priceCents
        taxRate
        bucketKeyName
        itemOptions{
          correlationId
          name
          description
          renderSequence
          isRequired
          itemOptionElements{
            correlationId
            name
            description
            renderSequence
            priceCents
          }
        }
      }
    }
  }
`;

export const UPDATE_COMBO = `mutation updateCombo($updateComboInput: UpdateComboInput!){
    updateCombo(updateComboInput: $updateComboInput){
      correlationId
      englishName
      nonEnglishName
      englishDescription
      nonEnglishDescription
      priceCents
      taxRate
      itemList{
      	correlationId
      	abbreviation
      	englishName
      	nonEnglishName
      	englishDescription
        nonEnglishDescription
        priceCents
        taxRate
        bucketKeyName
        itemOptions{
          correlationId
          name
          description
          renderSequence
          isRequired
          itemOptionElements{
            correlationId
            name
            description
            renderSequence
            priceCents
          }
        }
      }
    }
  }
`;

export const CREATE_PROMOTION = `mutation createPromotion($input: CreatePromotionInput!) {
  createPromotion(input: $input) {
    correlationId
    name
    status
    promotionType
    discountValue
    startsAt
    expiresAt
    maxRedemptionsTotal
  }
}
`;

export const UPDATE_PROMOTION = `mutation updatePromotion($input: UpdatePromotionInput!) {
  updatePromotion(input: $input) {
    correlationId
    name
    status
    promotionType
    discountValue
    startsAt
    expiresAt
    maxRedemptionsTotal
  }
}
`;

export const ACTIVATE_PROMOTION = `mutation activatePromotion($storeCorrelationId: UUID!, $promotionCorrelationId: UUID!) {
  activatePromotion(storeCorrelationId: $storeCorrelationId, promotionCorrelationId: $promotionCorrelationId) {
    correlationId
    status
  }
}
`;

export const PAUSE_PROMOTION = `mutation pausePromotion($storeCorrelationId: UUID!, $promotionCorrelationId: UUID!) {
  pausePromotion(storeCorrelationId: $storeCorrelationId, promotionCorrelationId: $promotionCorrelationId) {
    correlationId
    status
  }
}
`;

export const ARCHIVE_PROMOTION = `mutation archivePromotion($storeCorrelationId: UUID!, $promotionCorrelationId: UUID!) {
  archivePromotion(storeCorrelationId: $storeCorrelationId, promotionCorrelationId: $promotionCorrelationId) {
    correlationId
    status
    archivedAt
  }
}
`;

export const CREATE_PROMOTION_CODE = `mutation createPromotionCode($input: CreatePromotionCodeInput!) {
  createPromotionCode(input: $input) {
    correlationId
    promotionCorrelationId
    code
    normalizedCode
    status
    startsAt
    expiresAt
    maxRedemptionsTotal
    maxRedemptionsPerCustomer
    timesRedeemed
  }
}
`;

export const ADD_EMPLOYEE = `mutation registerStoreEmployee($createStoreEmployeeInput: CreateStoreEmployeeInput!){
  registerStoreEmployee(createStoreEmployeeInput: $createStoreEmployeeInput){
      correlationId
    }
}
`;

export const UPDATE_EMPLOYEE = `mutation updateStoreEmployee($updateStoreEmployeeInput: UpdateStoreEmployeeInput!){
    updateStoreEmployee(updateStoreEmployeeInput: $updateStoreEmployeeInput){
			  correlationId
        firstName
        lastName
        email
        phoneNumber
        employerName
        bucketKeyName
        stores{
          name
          correlationId
        }
    }
  }
`;

export const UPDATE_CUSTOMER_ORDER = `mutation updateCustomerOrder($updateCustomerOrderInput: UpdateCustomerOrderInput!){
    updateCustomerOrder(updateCustomerOrderInput: $updateCustomerOrderInput){
			 correlationId
    }
  }
`;

export const CREATE_CASH_PAYMENT = `mutation createCashPayment($createCashPaymentInput: CreateCashPaymentInput!){
  createCashPayment(createCashPaymentInput: $createCashPaymentInput) {
    correlationId
    storeCorrelationId
    paymentDate
    paymentAmountCents
    paymentMethodType
    paymentStatus
    customerOrderCorrelationId
    paymentType
    changeCents
  }
}`;

export const CREATE_CUSTOMER_ORDER_MUTATION = `mutation createCustomerOrder($createCustomerOrderInput: CreateCustomerOrderInput!){
  createCustomerOrder(createCustomerOrderInput: $createCustomerOrderInput){
    correlationId
    createdAt
    customerCorrelationId
    customerFirstName
    customerLastName
    customerEmail
    customerPhoneNumber
    storeCorrelationId
    storeName
    isGuest
    orderStatus
    orderType
    tableNumber
    totalItemQuantity
    customerNote
    serverFirstName
    serverLastName
    serverEmployeeCorrelationId
    paid
    tipCents
    subtotalCents
    totalTaxCents
    cardProcessingFeeCents
    cardProcessingFeePercentBps
    totalCents
    payment{
      paymentDate
      paymentAmountCents
      paymentMethodType
      paymentMethodBrand
      last4Digits
      paymentStatus
    }
    items{
      correlationId
      quantity
      isCombo
      englishName
      nonEnglishName
      englishDescription
      nonEnglishDescription
      basePriceCents
      optionsTotalCents
      unitPriceCents
      lineSubtotalCents
      lineTotalCents
      totalCents
      taxRate
      bucketKeyName
      itemOptionElements
      itemCorrelationId
    }

  }
}
`;

export const ADD_CUSTOMER = `mutation createCustomer($createCustomerInput: CreateCustomerInput!){
    createCustomer(createCustomerInput: $createCustomerInput) {
        correlationId 
    }
}
`;

export const UPDATE_CUSTOMER = `mutation updateCustomer($updateCustomerInput: UpdateCustomerInput!){
    updateCustomer(updateCustomerInput: $updateCustomerInput) {
        correlationId
    		firstName
    		lastName
    		email
    		phoneNumber
        address{
            addressLine1
            addressLine2
            city
            state
            zipCode
        }
    }
}
`;

export const CREATE_STORE_CUSTOMER = `mutation createStoreCustomer($storeCorrelationId: UUID!, $createCustomerInput: CreateCustomerInput!) {
  createStoreCustomer(storeCorrelationId: $storeCorrelationId, createCustomerInput: $createCustomerInput) {
    correlationId
  }
}
`;

export const UPDATE_STORE_CUSTOMER = `mutation updateStoreCustomer($updateStoreCustomerInput: UpdateStoreCustomerInput!) {
  updateStoreCustomer(updateStoreCustomerInput: $updateStoreCustomerInput) {
    correlationId
    name
    email
    phone
    addressLine1
    addressLine2
    city
    state
    zipCode
  }
}
`;

export const DELETE_STORE_CUSTOMER = `mutation deleteStoreCustomer($storeCorrelationId: UUID!, $storeCustomerCorrelationId: UUID!) {
  deleteStoreCustomer(storeCorrelationId: $storeCorrelationId, storeCustomerCorrelationId: $storeCustomerCorrelationId)
}
`;

export const CAPTURE_PAYMENT = `mutation captureCustomerOrderPayment($captureCustomerOrderPaymentInput: CaptureCustomerOrderPaymentInput!){
    captureCustomerOrderPayment(captureCustomerOrderPaymentInput: $captureCustomerOrderPaymentInput) {
      correlationId
      payment {
        correlationId
        storeCorrelationId
        paymentDate
        paymentAmountCents
        paymentMethodType
        paymentMethodBrand
        last4Digits
        paymentStatus
        customerOrderCorrelationId
        paymentType
        changeCents
        createdAt
      }
    }
}`;

export const MARK_ENTERPRISE_DISPATCH_SLIPS_PRINTED = `
  mutation MarkEnterpriseDispatchSlipsPrinted($input: MarkEnterpriseDispatchSlipsPrintedInput!) {
    markEnterpriseDispatchSlipsPrinted(input: $input) {
      correlationId
      enterpriseDispatchSlipPrintedAt
      enterpriseDispatchSlipPrintCount
      enterpriseDispatchSlipLastPrintedAt
      enterpriseDispatchSlipPrintedBy
    }
  }
`;

export const CAPTURE_TIP = `mutation captureCustomerOrderTip($captureCustomerOrderTipInput: CaptureCustomerOrderTipInput!){
  captureCustomerOrderTip(captureCustomerOrderTipInput: $captureCustomerOrderTipInput) {
  correlationId
  createdAt
  customerCorrelationId
  customerFirstName
  customerLastName
  customerEmail
  customerPhoneNumber
  storeCorrelationId
  storeName
  isGuest
  orderStatus
  orderType
  tableNumber
  totalItemQuantity
  customerNote
  serverFirstName
  serverLastName
  serverEmployeeCorrelationId
  paid
  subtotalCents
  totalTaxCents
  cardProcessingFeeCents
  cardProcessingFeePercentBps
  items{
    correlationId
    quantity
    isCombo
    englishName
    nonEnglishName
    englishDescription
    nonEnglishDescription
    basePriceCents
    optionsTotalCents
    unitPriceCents
    lineSubtotalCents
    lineTotalCents
    totalCents
    taxRate
    bucketKeyName
    itemOptionElements
    itemCorrelationId
  }
  tipCents
  payment{
    paymentDate
    paymentAmountCents
    paymentMethodType
    paymentMethodBrand
    last4Digits
    paymentStatus
  }
  }
}`;

export const DOWNLOAD_RECEIPT = `
          query receiptByCustomerOrderCorrelationIdForCustomers($customerOrderCorrelationId: UUID!) {
            receiptByCustomerOrderCorrelationIdForCustomers(
              customerOrderCorrelationId: $customerOrderCorrelationId
            )
          }
`;

export const ADD_CHANNEL = `
  mutation addChannel($addChannelInput: AddChannelInput!) {
    addChannel(addChannelInput: $addChannelInput) {
      correlationId
      name
      isActive
    }
  }
`;

export const UPDATE_CHANNEL = `
  mutation updateChannel($updateChannelInput: UpdateChannelInput!) {
    updateChannel(updateChannelInput: $updateChannelInput) {
      correlationId
      name
      isActive
    }
  }
`;

export const BULK_UPSERT_CHANNEL_ITEM_PRICES = `
  mutation bulkUpsertChannelItemPrices($input: BulkUpsertChannelItemPriceInput!) {
    bulkUpsertChannelItemPrices(input: $input) {
      correlationId
      storeCorrelationId
      channelCorrelationId
      itemCorrelationId
      priceCents
      isActive
    }
  }
`;

export const DEACTIVATE_CHANNEL_ITEM_PRICE = `
  mutation deactivateChannelItemPrice($input: DeactivateChannelItemPriceInput!) {
    deactivateChannelItemPrice(input: $input) {
      correlationId
      storeCorrelationId
      channelCorrelationId
      itemCorrelationId
      priceCents
      isActive
    }
  }
`;

export const ADD_MODIFIER_CATEGORY = `
  mutation addModifierCategory($addModifierCategoryInput: AddModifierCategoryInput!) {
    addModifierCategory(addModifierCategoryInput: $addModifierCategoryInput) {
      correlationId
      name
      modifierItems {
        correlationId
        name
      }
    }
  }
`;

export const UPDATE_MODIFIER_CATEGORY = `
  mutation updateModifierCategory($updateModifierCategoryInput: UpdateModifierCategoryInput!) {
    updateModifierCategory(updateModifierCategoryInput: $updateModifierCategoryInput) {
      correlationId
      name
      active
    }
  }
`;

export const ADD_EVENT = `
  mutation addEvent($addEventInput: AddEventInput!) {
    addEvent(addEventInput: $addEventInput) {
      correlationId
      storeCorrelationId
      eventName
      eventDescription
      startDate
      endDate
      startTimeInSeconds
      endTimeInSeconds
      active
      eventItems {
        correlationId
        itemCorrelationId
        discountType
        discountPercent
        discountFixedPriceCents
        finalPriceCents
      }
      recurrences {
        correlationId
        recurrenceRule
      }
    }
  }
`;

export const UPDATE_EVENT = `
  mutation updateEvent($updateEventInput: UpdateEventInput!) {
    updateEvent(updateEventInput: $updateEventInput) {
      correlationId
      storeCorrelationId
      eventName
      eventDescription
      startDate
      endDate
      startTimeInSeconds
      endTimeInSeconds
      active
      eventItems {
        correlationId
        itemCorrelationId
        discountType
        discountPercent
        discountFixedPriceCents
        finalPriceCents
      }
      recurrences {
        correlationId
        recurrenceRule
      }
    }
  }
`;

export const ADD_MODIFIER_ITEM = `
  mutation addModifierItem($addModifierItemInput: AddModifierItemInput!) {
    addModifierItem(addModifierItemInput: $addModifierItemInput) {
      correlationId
      name
      nonEnglishName
      taxRate
      modifierItemOptions {
        correlationId
        name
        nonEnglishName
        priceCents
        renderSequence
      }
    }
  }
`;

export const UPDATE_MODIFIER_ITEM = `
  mutation updateModifierItem($updateModifierItemInput: UpdateModifierItemInput!) {
    updateModifierItem(updateModifierItemInput: $updateModifierItemInput) {
      correlationId
      name
      nonEnglishName
      taxRate
      active
      modifierItemOptions {
        correlationId
        name
        nonEnglishName
        priceCents
        renderSequence
      }
    }
  }
`;

export const ADD_MODIFIER_ITEM_OPTION = `
  mutation addModifierItemOption($addModifierItemOptionInput: AddModifierItemOptionInput!) {
    addModifierItemOption(addModifierItemOptionInput: $addModifierItemOptionInput) {
      correlationId
      name
      nonEnglishName
      translations {
        locale
        name
        description
      }
    }
  }
`;

export const UPDATE_MODIFIER_ITEM_OPTION = `
  mutation updateModifierItemOption($updateModifierItemOptionInput: UpdateModifierItemOptionInput!) {
    updateModifierItemOption(updateModifierItemOptionInput: $updateModifierItemOptionInput) {
      correlationId
      name
      nonEnglishName
      translations {
        locale
        name
        description
      }
    }
  }
`;

export const REGISTER_NMI_DEVICE = `
  mutation registerNmiDevice($registerTerminalInput: RegisterTerminalInput!) {
    registerNmiDevice(registerTerminalInput: $registerTerminalInput) {
      correlationId
      storeCorrelationId
      name
      terminalType
      provider
      providerTerminalId
      serialNumber
      active
      lastSeenAt
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_TERMINAL = `
  mutation createTerminal($createTerminalInput: CreateTerminalInput!) {
    createTerminal(createTerminalInput: $createTerminalInput) {
      correlationId
      storeCorrelationId
      name
      terminalType
      provider
      providerTerminalId
      serialNumber
      active
      lastSeenAt
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_TERMINAL = `
  mutation updateTerminal($updateTerminalInput: UpdateTerminalInput!) {
    updateTerminal(updateTerminalInput: $updateTerminalInput) {
      correlationId
      storeCorrelationId
      name
      terminalType
      provider
      providerTerminalId
      serialNumber
      active
      lastSeenAt
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_TERMINAL = `
  mutation deleteTerminal($terminalCorrelationId: UUID!) {
    deleteTerminal(terminalCorrelationId: $terminalCorrelationId)
  }
`;

export const DEREGISTER_NMI_DEVICE = `
  mutation deregisterNmiDevice($terminalCorrelationId: UUID!) {
    deregisterNmiDevice(terminalCorrelationId: $terminalCorrelationId)
  }
`;

export const SET_DEFAULT_TERMINAL = `
  mutation setDefaultTerminal($stationCorrelationId: UUID!, $terminalCorrelationId: UUID) {
    setDefaultTerminal(stationCorrelationId: $stationCorrelationId, terminalCorrelationId: $terminalCorrelationId) {
      correlationId
      defaultTerminalId
      defaultTerminalCorrelationId
    }
  }
`;

export const SET_DEFAULT_RECEIPT_PRINTER = `
  mutation setDefaultReceiptPrinter($stationCorrelationId: UUID!, $storePrinterCorrelationId: UUID) {
    setDefaultReceiptPrinter(stationCorrelationId: $stationCorrelationId, storePrinterCorrelationId: $storePrinterCorrelationId) {
      correlationId
      defaultReceiptPrinterCorrelationId
    }
  }
`;

export const SET_STATION_CUSTOMER_DISPLAY_ENABLED = `
  mutation setStationCustomerDisplayEnabled($stationCorrelationId: UUID!, $customerDisplayEnabled: Boolean!) {
    setStationCustomerDisplayEnabled(stationCorrelationId: $stationCorrelationId, customerDisplayEnabled: $customerDisplayEnabled) {
      correlationId
      customerDisplayEnabled
    }
  }
`;

export const UPDATE_TIP_AUTH_CONFIG = `
  mutation updateTipAuthConfig($updateTipAuthConfigInput: UpdateTipAuthConfigInput!) {
    updateTipAuthConfig(updateTipAuthConfigInput: $updateTipAuthConfigInput) {
      tipAuthBufferPercentage
      tipAuthMinDollarCents
      tipAuthMaxDollarCents
    }
  }
`;

/** One mutation for all tip-related settings. Send only the fields the form manages. */
export const UPDATE_STORE_TIP_SETTINGS = `
  mutation updateStoreTipSettings($updateStoreTipSettingsInput: UpdateStoreTipSettingsInput!) {
    updateStoreTipSettings(updateStoreTipSettingsInput: $updateStoreTipSettingsInput) {
      correlationId
      tipAuthBufferPercentage
      tipAuthMinDollarCents
      tipAuthMaxDollarCents
      dineInAutoTipPartySizeThreshold
      dineInAutoTipPercentage
      suggestedTipPercentages {
        tipPercentage
      }
    }
  }
`;

// ——— Work sessions (clock in/out) ———

export const EMPLOYEE_CLOCK_IN = `
  mutation EmployeeClockIn($workSessionInput: WorkSessionInput!) {
    employeeClockIn(workSessionInput: $workSessionInput) {
      id
      clockInAt
      clockOutAt
      notes
      storeCorrelationId
      userCorrelationId
      workDate
    }
  }
`;

export const EMPLOYEE_CLOCK_OUT = `
  mutation EmployeeClockOut($workSessionInput: WorkSessionInput!) {
    employeeClockOut(workSessionInput: $workSessionInput) {
      id
      clockInAt
      clockOutAt
      notes
      storeCorrelationId
      userCorrelationId
      workDate
    }
  }
`;

// ——— Cash drawer ———

export const CASH_TRANSACTION_CREATE = `
  mutation cashTransactionCreate($input: CreateCashTransactionInput!) {
    cashTransactionCreate(input: $input) {
      correlationId
      storeCorrelationId
      transactionType
      amountCents
      balanceAfter
      createdAt
      note
      relatedPaymentId
      createdByUserCorrelationId
    }
  }
`;

export const ORDER_READY_SMS_EFFECTIVE = `
  query OrderReadySmsEffective($storeCorrelationId: UUID!) {
    orderReadySmsEffective(storeCorrelationId: $storeCorrelationId) {
      pickupEnabled
      deliveryEnabled
    }
  }
`;

export const UPDATE_STORE_MESSAGING_SETTINGS = `
  mutation UpdateStoreMessagingSettings($input: UpdateStoreMessagingSettingsInput!) {
    updateStoreMessagingSettings(input: $input) {
      pickupEnabled
      deliveryEnabled
    }
  }
`;


export const UPDATE_ENTERPRISE_STORE_WEEKDAY_CAPACITIES = `
  mutation UpdateEnterpriseStoreWeekdayCapacities($input: UpdateEnterpriseStoreWeekdayCapacitiesInput!) {
    updateEnterpriseStoreWeekdayCapacities(input: $input) {
      dayOfWeek
      capacity
      active
    }
  }
`;
